import { useQuery } from 'react-query';
import { baseURL } from 'Types/APITypes';
import { CommercialProducts } from 'components/CommercialProducts/CommercialProductsFields';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';

const getCommercialProducts = (locationNumber: string) => maestroApiCall(
  { method: 'GET', endpoint: `/locations/${locationNumber}/commercial-products`, baseURL },
);

export default function useCommercialProducts(locationNumber: string) {
  return useQuery<CommercialProducts>(['commercial-products', locationNumber], () => getCommercialProducts(locationNumber), {
    cacheTime: 3600,
    keepPreviousData: true,
  });
}

interface saveParams {
  stNumber: string,
  data: any
}

export async function saveCommercialProducts({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/commercial-products`, baseURL };
  const response = await maestroApiCall(apiType, data).then((res) => res.data);
  return response;
}
